"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SKIP_TO_COMMAND = exports.SESSION_EXPIRED = exports.REQUEST_BALANCE = exports.RECONNECTING = exports.RECONNECTED = exports.DISCONNECTED = exports.DISCONNECT = exports.ConnectionState = exports.CONNECTION_FAILED = exports.CONNECTED = exports.CONNECT = exports.COMMAND_SEND = exports.COMMAND_RESUME = exports.COMMAND_RECEIVED = exports.COMMAND_QUEUE_NEXT = exports.COMMAND_QUEUE = exports.COMMAND_PLAY = exports.COMMAND_PAUSE = exports.COMMAND_FEATURE_STORE_CLEAR = exports.COMMAND_FEATURE_STORE = void 0;
var ConnectionState = exports.ConnectionState = /*#__PURE__*/function (ConnectionState) {
  ConnectionState[ConnectionState["None"] = 0] = "None";
  ConnectionState[ConnectionState["Failed"] = 1] = "Failed";
  ConnectionState[ConnectionState["Disconnected"] = 2] = "Disconnected";
  ConnectionState[ConnectionState["Connecting"] = 3] = "Connecting";
  ConnectionState[ConnectionState["Connected"] = 4] = "Connected";
  ConnectionState[ConnectionState["Reconnecting"] = 5] = "Reconnecting";
  return ConnectionState;
}({}); // reconnecting.
//  Reconnected // have reconnected at least once.
var CONNECT = exports.CONNECT = "CONNECT";
var CONNECTED = exports.CONNECTED = "CONNECTED";
var CONNECTION_FAILED = exports.CONNECTION_FAILED = "CONNECTION_FAILED";
var DISCONNECT = exports.DISCONNECT = "DISCONNECT";
var DISCONNECTED = exports.DISCONNECTED = "DISCONNECTED";
var RECONNECTING = exports.RECONNECTING = "RECONNECTING";
var RECONNECTED = exports.RECONNECTED = "RECONNECTED";
var SESSION_EXPIRED = exports.SESSION_EXPIRED = "SESSION_EXPIRED";
var COMMAND_SEND = exports.COMMAND_SEND = "COMMAND_SEND";
var COMMAND_RECEIVED = exports.COMMAND_RECEIVED = "COMMAND_RECEIVED";
var COMMAND_PAUSE = exports.COMMAND_PAUSE = "COMMAND_PAUSE";
var COMMAND_RESUME = exports.COMMAND_RESUME = "COMMAND_RESUME";
var COMMAND_PLAY = exports.COMMAND_PLAY = "COMMAND_PLAY";
var COMMAND_QUEUE = exports.COMMAND_QUEUE = "COMMAND_QUEUE";
var COMMAND_QUEUE_NEXT = exports.COMMAND_QUEUE_NEXT = "COMMAND_QUEUE_NEXT";
var COMMAND_FEATURE_STORE = exports.COMMAND_FEATURE_STORE = "COMMAND_FEATURE_STORE";
var COMMAND_FEATURE_STORE_CLEAR = exports.COMMAND_FEATURE_STORE_CLEAR = "COMMAND_FEATURE_STORE_CLEAR";
var REQUEST_BALANCE = exports.REQUEST_BALANCE = "REQUEST_BALANCE";
var SKIP_TO_COMMAND = exports.SKIP_TO_COMMAND = "SKIP_TO_COMMAND";
//Actions
//# sourceMappingURL=types.js.map